import React from 'react'
import { Headings, IconScroll } from '../../components';
import { data } from '../../constants';
import './CaseStudies.css';
import { FiArrowUpRight } from 'react-icons/fi'


const CaseStudies = () => {
  return (
    <div className="section-padding" id="desire">

      <Headings title="নিবেদন" text="" />

        <div className="case-studies">

          {data.CaseStudies.map(({ text, link, title }, index) => (
            <div key={link} className="case-studies-item">
              <h4>{title}</h4>
              <p>{text}</p>
              <a href={link} alt="Learn more">Learn more <FiArrowUpRight /></a>
            </div>
          ))}
        </div>
        
    <IconScroll />
   
      </div>

  )
}

export default CaseStudies